/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Quick_Add_NewInputs */

const en_quick_add_new = /** @type {(inputs: Quick_Add_NewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.name}” as a new item`)
};

const de_quick_add_new = /** @type {(inputs: Quick_Add_NewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.name}“ als neuer Artikel`)
};

/**
* | output |
* | --- |
* | "“{name}” as a new item" |
*
* @param {Quick_Add_NewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_add_new = /** @type {((inputs: Quick_Add_NewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Add_NewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_quick_add_new(inputs)
	return en_quick_add_new(inputs)
});